import { apiFetch } from "@/client/lib/api";

/**
 * Staff "view as tenant" (read-only impersonation) client.
 *
 * `start` runs on the internal staff host and returns a customer-host URL to
 * navigate to (the cross-host handoff). `exit` ends the session and returns the
 * internal URL to return to. Both are full navigations, not in-app routes,
 * because they cross hosts and set/clear an httpOnly cookie server-side.
 */
export const impersonationApi = {
  start: (tenantId: string) =>
    apiFetch<{ url: string }>(`/impersonate/tenants/${encodeURIComponent(tenantId)}/start`, {
      method: "POST",
    }),
  exit: () => apiFetch<{ url: string }>("/impersonate/exit", { method: "POST" }),
};
